import {
  plainToClassFromExist,
  plainToInstance,
  instanceToPlain,
  instanceToInstance,
} from 'class-transformer';
import type dayjs from 'dayjs';
import { TransformStringToDayJS } from './utils';

export abstract class BaseType {
  static fromJson<T extends BaseType>(this: new () => T, json: any): T {
    return plainToInstance(this, json, {
      exposeDefaultValues: true,
      exposeUnsetFields: true,
      enableImplicitConversion: true,
    });
  }

  constructor(json?: any) {
    if (json) {
      this.updateFromJson(json);
    }
  }

  updateFromJson(json: any): void {
    plainToClassFromExist(this, json, {
      exposeDefaultValues: false,
      exposeUnsetFields: true,
      enableImplicitConversion: true,
    });
  }

  clone() {
    return instanceToInstance(this, {
      exposeDefaultValues: true,
      exposeUnsetFields: true,
      enableImplicitConversion: true,
    });
  }

  toJson(): Record<string, any> {
    return instanceToPlain(this);
  }
}

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export abstract class Model extends BaseType {
  @TransformStringToDayJS()
  created_at: dayjs.Dayjs;

  @TransformStringToDayJS()
  modified_at: dayjs.Dayjs | null = null;

  object: string;
}
